import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { FeatureSubscriptionWriteDTO } from '../interfaces/featureSubscription';

@Injectable({
  providedIn: 'root'
})
export class FeatureSubscriptionService {

    constructor(private dataService: DataService) { }
  
    getFeatureSubscriptions() {
      return this.dataService.getFeatureSubscriptions();
    }

    deleteFeatureSubscription(id: number) {
      return this.dataService.deleteFeatureSubscription(id);
    }

    createFeatureSubscription(featureSubscription: FeatureSubscriptionWriteDTO) {
      return this.dataService.createFeatureSubscription(featureSubscription);
    }
}
